"use strict";
/**
 * @module Services.TopicNotifications
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var conversation_id_serialiser_1 = require("./../../conversation/conversation-id-serialiser");
var serialiser_1 = require("./../../serialisers/serialiser");
/**
 * Serialiser for {@link TopicNotificationDeregistrationRequest}
 */
var TopicNotificationDeregistrationRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(TopicNotificationDeregistrationRequestSerialiserClass, _super);
    function TopicNotificationDeregistrationRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link TopicNotificationDeregistrationRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link TopicNotificationDeregistrationRequest} to be written
     */
    TopicNotificationDeregistrationRequestSerialiserClass.prototype.write = function (bos, value) {
        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.cid);
    };
    return TopicNotificationDeregistrationRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.TopicNotificationDeregistrationRequestSerialiserClass = TopicNotificationDeregistrationRequestSerialiserClass;
/**
 * The {@link TopicNotificationDeregistrationRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.TopicNotificationDeregistrationRequestSerialiser = new TopicNotificationDeregistrationRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-notifications/topic-notification-deregistration-request-serialiser.js
// module id = 2006
// module chunks = 1